import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["text", "icon"];

  connect() {
    // Set the smart back button behavior based on browser history
    this.setSmartBackButton();
  }

  setSmartBackButton() {
    // The core insight: The browser knows its own history better than we do.
    // window.history.length tells us how many pages are in the session history for this tab.

    // If the history length is 1, it means the user landed directly on this page from an external source,
    // or opened it in a new tab. There is no "back" to go to.
    if (window.history.length <= 1) {
      // --- FALLBACK STATE: Send them to the calendar ---
      this.element.href = "/calendar";

      if (this.hasTextTarget) {
        this.textTarget.textContent = "View Full Calendar";
      }

      // Update icon to calendar icon
      if (this.hasIconTarget) {
        this.iconTarget.innerHTML = `
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        `;
      }
    } else {
      // --- BACK STATE: True history-based back button ---
      // If there is any history at all, we trust it and make this a true "back" button
      this.element.href = "#"; // Prevent the link from navigating anywhere on its own

      this.element.addEventListener("click", (e) => {
        e.preventDefault();
        window.history.back();
      });

      if (this.hasTextTarget) {
        this.textTarget.textContent = "Back";
      }

      // Keep the existing back arrow icon
      if (this.hasIconTarget) {
        this.iconTarget.innerHTML = `
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        `;
      }
    }
  }
}
